export default {
  // 页面标题
  title: "Hạn mức mẫu",
  detailTitle: "Chi tiết hạn mức mẫu",

  // 表格列
  shopInfo: "Thông tin cửa hàng",
  supplierName: "Thuộc chuỗi cung ứng",
  activeProductCount: "Số sản phẩm hoạt động",
  quotaLessThan30: "Hạn mức mẫu ≤30",
  quotaEqualsZero: "Hạn mức mẫu =0",
  follower: "PC cửa hàng",
  activeProducts: "sản phẩm hoạt động",
  view: "Xem",

  // 详情表格
  productInfo: "Thông tin sản phẩm",
  activityInfo: "Thông tin hoạt động",
  remainingQuota: "Hạn mức còn lại",
  activityId: "ID hoạt động",
  copySuccess: "Đã sao chép liên kết hoạt động",
  copyLink: "Sao chép liên kết hoạt động",
  zeroQuotaWarning: "Hạn chế đăng ký, liên hệ với nhà bán hàng để bổ sung hạn mức mẫu!",
  lowQuotaWarning: "Sắp hết hạn mức, liên hệ với nhà bán hàng để bổ sung hạn mức mẫu!",

  // 搜索表单
  shopName: "Tên cửa hàng",
  shopCode: "ID cửa hàng",
  inputShopName: "Vui lòng nhập tên cửa hàng",
  inputShopCode: "Vui lòng nhập ID cửa hàng",
  inputSupplierName: "Vui lòng nhập tên chuỗi cung ứng",
  selectFollower: "Vui lòng chọn PC cửa hàng",

  // 其他
  onlyShowLowQuota: "Chỉ hiển thị các cửa hàng cần bổ sung hạn mức",

  // Alert messages
  alertMessage: "Sản phẩm có hạn mức mẫu bằng 0 không thể đăng ký lấy mẫu",
  alertDescription: "Vui lòng thông báo cho người bán để bổ sung hạn mức kịp thời",
  howToReplenish: "Làm thế nào để bổ sung?"
};
